module.exports = __webpack_public_path__ + "Gotham-Black.9800b8683fa7dc3b3a3c.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/vijay/projects/customers-app/src/assets/fonts/gotham/Gotham-Black.ttf
// module id = ../../../../../src/assets/fonts/gotham/Gotham-Black.ttf
// module chunks = styles